//RAW DATA
export const GET_SELECTED_ELECTRICAL_ID_DATA = 'GET_ELECTRICAL_ID_DATA';
export const ERROR_SELECTED_ELECTRICAL_ID_DATA = 'ERROR_ELECTRICAL_ID_DATA';
export const CLEAR_SELECTED_ELECTRICAL_ID_DATA = 'CLEAR_ELECTRICAL_ID_DATA';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_FAIL';